const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');

const TOOLTIP =
    "Filter a given control's contents based on the record selected in the Navigation. E.g. Items tagged with an inventory. Requires to be on a Navigation Selected Context Page.";

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    let workspace = blocklyBlock.workspace;
    let blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged horizontally (default).
    //Meaning everything goes on one line
    blocklyBlock.setInputsInline(false);
    line1OfInputs
        .appendField('   Navigation Namespace:')
        .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
        .appendField('  Navigation Relation:')
        .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['namespace', 'relation']);
    return code;
}

/** Builds the filter metadata fragment for the ByNavigationSelection block. */
function asDataDictionary(hNode, context) {
    const { namespace, relation } = hNode;
    //We know that the referenced namespace/relation must exist
    let subDataDictionary = {};
    //And the given foreignKey exists on the parent object.
    // Filters always require the foreign key reference
    return [subDataDictionary, context.registerForeignKey(namespace, relation, [])];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
